

import auth from '@/modules/Auth'
import logger from '@/modules/Logger'
import backend from '@/modules/Backend'
import router from '../router'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {getBackendHost} from './libs/misc'

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      log: {},
      authenticated: false,
      attachmentLink: getBackendHost(window.location) + '/filestore/test'
    }
  },
  components: {
    Cell,
    Group
  },
  methods: {
    load () {
      this.log = logger.get()
      this.authenticated = auth.isSessionAuthenticated()
    },

    register () {
      router.push('register')
    },

    resetLogger () {
      logger.reset()
      this.log = logger.get()
    },
    switchUser () {
      router.push('confirm')
    },
    unlink () {
      backend.unlink().then(() => {
        router.push('logout')
      })
    },
    logout () {
      auth.logout().then(() => {
        this.load()
      })
    }
  },
  mounted () {
    this.load()
  }
}



// WEBPACK FOOTER //
// ./src/components/Debug.vue